import { first, orderBy } from 'lodash';
import helper from './helper';

export default (xScale, mouseEvents) => (selection) => {
  selection.selectAll('.marker').remove();

  const { onIconCarClick, onDropMouseover, onDropMouseout } = mouseEvents;
  const data = first(selection.data());
  const {
    destinations,
    total_percentage,
  } = data;
  const destinationsSorted = orderBy(destinations, ['percentage'], ['desc']);
  const bars = helper.getXDestinationValue(destinationsSorted);
  const dtProgress = { ...bars.pop(), shipmentData: data };
  const truckLink = 'https://secure-gps.street-directory.com.au/assets/img/tms/truck.png';

  const marker = selection.selectAll('.marker').data([dtProgress]);
  const gMarker = marker
    .enter()
    .append('g')
    .classed('marker', true);

  if (total_percentage !== 0) {
    const domain = xScale.domain();
    const offsetLeft = dtProgress.end < domain[0];
    const offsetRight = dtProgress.end > domain[1];

    if (offsetLeft || offsetRight) { return false; }
  }

  gMarker
    .append('image')
    .classed('truck__progress', true)
    .on('click', onIconCarClick())
    .on('mouseover', onDropMouseover('current'))
    .on('mouseout', onDropMouseout())
    .style('cursor', 'pointer')
    .style('transform', (d) => {
      const markerPos = total_percentage === 0 ? xScale(0) : xScale(d.end) - 30;
      return `translate(${markerPos}px, 3px)`;
    })
    .attr('height', 30)
    .attr('xlink:href', truckLink);

  // gMarker
  //   .append('rect')
  //   .classed('percentage__total', true)
  //   .attr('fill', '#FFC107')
  //   .attr('height', 15)
  //   .attr('width', 35)
  //   .attr('rx', 7)
  //   .attr('ry', 7)
  //   .attr('x', d => (total_percentage === 0 ? xScale(0) : xScale(d.end) - 30))
  //   .attr('y', 4);

  // gMarker
  //   .append('text')
  //   .style('fill', 'black')
  //   .style('font-weight', 'bold')
  //   .attr('y', 15)
  //   .append('tspan')
  //   .attr('text-anchor', 'middle')
  //   .attr('x', d => (total_percentage === 0 ? xScale(0) + 20 : xScale(d.end) - 13))
  //   .text(`${Math.round(data.total_percentage)}%`);

  gMarker
    .append('rect')
    .classed('percentage__progress', true)
    .attr('fill', '#FFC107')
    .attr('height', 15)
    .attr('width', 35)
    .attr('rx', 7)
    .attr('ry', 7)
    .attr('x', d => (total_percentage === 0 ? xScale(0) : xScale(d.end) - 30))
    .attr('y', 45);

  gMarker
    .append('text')
    .style('fill', 'black')
    .style('font-weight', 'bold')
    .attr('y', 56)
    .attr('text-anchor', 'middle')
    .attr('x', d => (total_percentage === 0 ? xScale(0) + 18 : xScale(d.end) - 13))
    .text(() => `${total_percentage === 0 ? 0 : Math.round(data.total_percentage)}%`);

  return marker;
};



// WEBPACK FOOTER //
// ./src/views/pages/completion/marker.js